module.exports = "li a {\n  display: block; }\n\nli {\n  float: left;\n  list-style-type: none;\n  width: 10%; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/alert-history/alert-history.component.scss
// module id = ./client/app/alert-history/alert-history.component.scss
// module chunks = main